module.exports = __webpack_public_path__ + "static/media/TableSplit_Before.8270abab.jpg";